import { render, staticRenderFns } from "./ListSubRegion.vue?vue&type=template&id=75b106fa&scoped=true"
import script from "./ListSubRegion.vue?vue&type=script&lang=js"
export * from "./ListSubRegion.vue?vue&type=script&lang=js"
import style0 from "./ListSubRegion.vue?vue&type=style&index=0&id=75b106fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b106fa",
  null
  
)

export default component.exports